import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, DialogClose } from '../ui/dialog';
import { Leaf } from 'lucide-react';
import { mockTarifs } from '../../mock/mock';

const BOOKING_URL = 'https://perfactive.fr/laura-body/new?people=26749';

export const TarifsSection = () => (
  <section id="tarifs" className="tarifs-section">
    <div className="section-container">
      <div className="section-header">
        <span className="section-label">Nos Tarifs</span>
        <h2 className="section-title">Tarifs - Laura Body Naturopathe et Réflexologue Angoulême</h2>
      </div>
      <div className="tarifs-grid">
        {mockTarifs.map((tarif) => (
          <Card key={tarif.name} className={`tarif-card ${tarif.popular ? 'popular' : ''}`}>
            {tarif.popular && <div className="popular-badge">Populaire</div>}
            <CardHeader>
              <CardTitle className="tarif-name">{tarif.name}</CardTitle>
              <div className="tarif-price">
                {tarif.oldPrice && (
                  <span className="price-old">{tarif.oldPrice}€</span>
                )}
                <span className="price-amount">{tarif.price}€</span>
                <span className="price-duration">/ {tarif.duration}</span>
              </div>
              <CardDescription className="tarif-description">
                {tarif.description}
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="tarif-includes">
                {tarif.includes.map((item) => (
                  <li key={item} className="include-item">
                    <Leaf className="include-icon" />
                    {item}
                  </li>
                ))}
              </ul>
              <a href={BOOKING_URL} target="_blank">
                <Button className={`btn-tarif ${tarif.popular ? 'popular-btn' : ''}`}>
                  Réserver maintenant
                </Button>
              </a>
              <TarifDialog tarif={tarif} />
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  </section>
);

const TarifDialog = ({ tarif }) => {
  const dialogContent = TARIF_DIALOGS[tarif.name];
  if (!dialogContent) return null;

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" className="btn-info-tarif">En savoir plus</Button>
      </DialogTrigger>
      <DialogContent className="shirotchampi-dialog">
        <DialogHeader>
          <DialogTitle className="dialog-title">{dialogContent.title}</DialogTitle>
          <DialogDescription className="dialog-description">{dialogContent.subtitle}</DialogDescription>
        </DialogHeader>
        <div className="dialog-body">{dialogContent.body}</div>
        <div className="dialog-footer-close">
          <DialogClose asChild>
            <Button className="btn-close-dialog">Fermer</Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const TARIF_DIALOGS = {
  'Consultation Naturopathique': {
    title: 'Consultation Naturopathique',
    subtitle: 'Bilan complet personnalisé',
    body: (
      <>
        <div className="info-section">
          <p>La naturopathie est une approche de santé holistique qui met l'accent sur la prévention et le maintien du bien-être global. Elle s'appuie sur des méthodes naturelles et individualisées afin d'aider chaque personne à retrouver et préserver son équilibre.</p>
        </div>
        <div className="benefit-section">
          <h3 className="benefit-section-title">Ma spécialisation :</h3>
          <p className="specialization-text">Je me suis spécialisée dans les troubles cutanés, un domaine qui m'a personnellement concernée. Je sais à quel point ces problématiques peuvent être difficiles à vivre au quotidien. C'est pourquoi je souhaite mettre mes connaissances et mon expérience au service de votre mieux-être, afin de vous accompagner pas à pas vers une amélioration durable de votre peau.</p>
        </div>
        <div className="info-section">
          <p><strong>Acné, eczéma, psoriasis, rosacée…</strong> si vous êtes concerné(e), vous êtes au bon endroit. Ensemble, nous chercherons à comprendre l'origine de ces déséquilibres pour vous aider à retrouver une peau plus saine et un équilibre global.</p>
        </div>
      </>
    )
  },
  'Séance Réflexologie Plantaire': {
    title: 'Séance Réflexologie Plantaire',
    subtitle: 'Détente et rééquilibrage énergétique',
    body: (
      <div className="benefit-section">
        <h3 className="benefit-section-title">Les bienfaits de la réflexologie :</h3>
        <ul className="benefit-list">
          <li>Gestion du stress</li>
          <li>Dynamisme de l'organisme</li>
          <li>Harmonise les fonctions vitales</li>
          <li>Libère les tensions du dos</li>
          <li>Améliore la circulation sanguine</li>
          <li>Apporte détente et relaxation profonde</li>
          <li>Active le système lymphatique et décontracte les muscles</li>
          <li>Soulage les troubles du sommeil</li>
          <li>Soulage les migraines et maux de tête</li>
          <li>Les ruminations et pensées négatives</li>
          <li>Gestion des émotions</li>
        </ul>
      </div>
    )
  },
  'Massage Shirotchampi': {
    title: 'Massage Shirotchampi',
    subtitle: 'Massage ayurvédique du cuir chevelu, visage, cou et épaules',
    body: (
      <>
        <div className="benefit-section">
          <h3 className="benefit-section-title">Bienfaits physiques :</h3>
          <ul className="benefit-list">
            <li>Amélioration de la santé des cheveux et du cuir chevelu</li>
            <li>Soulagement des maux de tête</li>
            <li>Détente des tensions musculaires</li>
            <li>Stimulation de la circulation sanguine</li>
            <li>Soutien des processus de détoxification</li>
          </ul>
        </div>
        <div className="benefit-section">
          <h3 className="benefit-section-title">Bienfaits mentaux et émotionnels :</h3>
          <ul className="benefit-list">
            <li>Réduction du stress et de l'anxiété</li>
            <li>Amélioration de la clarté mentale et de la concentration</li>
            <li>Induction d'un état de calme profond et de relaxation</li>
            <li>Favorise un sommeil plus réparateur</li>
          </ul>
        </div>
        <div className="info-section">
          <p>Lors de la séance, une huile végétale est utilisée. Vous aurez le choix entre une huile de coco ou une huile de pépins de raisin.</p>
        </div>
      </>
    )
  },
  'Massage Rose Équilibre': {
    title: 'Massage Rose Équilibre',
    subtitle: 'Soin réservé aux femmes – Massage holistique corps et esprit',
    body: (
      <>
        <div className="info-section">
          <p>Le Massage Rose Équilibre est un massage du corps inspiré d'une approche holistique, dont l'objectif est de favoriser un profond sentiment de bien-être, d'harmonie et d'équilibre entre le corps et l'esprit.</p>
        </div>
        <div className="benefit-section">
          <h3 className="benefit-section-title">Les bienfaits de ce massage :</h3>
          <p>Ce soin vous invite à vivre un véritable moment de détente et peut contribuer à :</p>
          <ul className="benefit-list">
            <li>Apaiser le système nerveux</li>
            <li>Favoriser un profond lâcher-prise</li>
            <li>Retrouver un sentiment d'équilibre intérieur</li>
            <li>Procurer une sensation de réconfort et de sécurité</li>
            <li>Accompagner les périodes de stress, de fatigue émotionnelle ou de surcharge mentale</li>
            <li>Favoriser une meilleure connexion à soi et un état de sérénité</li>
          </ul>
        </div>
        <div className="benefit-section">
          <h3 className="benefit-section-title">Un soin aux actifs naturels :</h3>
          <ul className="benefit-list">
            <li><strong>Huile essentielle de Rose de Damas</strong> — Véritable joyau de l'aromathérapie, reconnue pour son parfum délicat et enveloppant. Traditionnellement utilisée pour favoriser l'apaisement émotionnel, soutenir la confiance en soi et encourager l'ouverture du cœur.</li>
            <li><strong>Quartz rose</strong> — Symbole de douceur et d'amour de soi, cette pierre est associée à l'apaisement et au réconfort. Utilisé pendant le massage, il favorise une sensation de bien-être et de sérénité.</li>
            <li><strong>Huile essentielle de Pamplemousse</strong> — Appréciée pour son parfum frais et tonique, elle participe à la sensation de jambes légères et accompagne les soins dédiés au confort de la peau.</li>
            <li><strong>Huile essentielle de Cyprès</strong> — Connue pour ses propriétés tonifiantes sur la circulation veineuse, elle procure une agréable sensation de légèreté.</li>
          </ul>
        </div>
        <div className="info-section">
          <p>Le Massage Rose Équilibre est une invitation à ralentir, à vous recentrer et à prendre soin de vous. Grâce à l'association du massage, des huiles essentielles et du quartz rose, ce soin vous offre une parenthèse de douceur pour retrouver calme, harmonie et bien-être.</p>
        </div>
      </>
    )
  },
  'Pack Cutané': {
    title: 'Pack Cutané',
    subtitle: 'Accompagnement complet pour soulager vos troubles cutanés',
    body: (
      <>
        <div className="info-section">
          <p>Dans ce pack, je vous accompagne pour soulager vos troubles cutanés, qu'il s'agisse d'acné, d'eczéma, de psoriasis ou encore de rosacée.</p>
          <p>Pour vous aider au mieux, je combine mes deux pratiques afin de vous proposer un accompagnement complet et global. Cette formule comprend 4 séances de naturopathie, visant à agir à la racine du déséquilibre à l'origine de vos troubles cutanés, ainsi que 4 séances de réflexologie, au cours desquelles j'utilise des techniques réflexes pour aider votre corps à stimuler ses capacités naturelles d'auto-régulation.</p>
          <p>La combinaison de la naturopathie et de la réflexologie est particulièrement complémentaire. Elle permet un accompagnement en profondeur, favorisant à la fois le mieux-être, la détente et l'équilibre global du corps.</p>
          <p>Cette formule a également pour objectif de vous aider à reprendre confiance en vous. S'accorder ces moments pour soi est essentiel et constitue une véritable aide tout au long de votre parcours vers l'amélioration et l'apaisement de vos troubles cutanés.</p>
        </div>
        <div className="benefit-section">
          <h3 className="benefit-section-title">Ce pack comprend :</h3>
          <ul className="benefit-list">
            <li>4 séances de naturopathie</li>
            <li>4 séances de réflexologie</li>
            <li>Accompagnement global et personnalisé</li>
            <li>Combinaison naturopathie + réflexologie</li>
          </ul>
        </div>
        <div className="info-section">
          <p><strong>Total des 4 séances de naturopathie et des 4 séances de réflexologie : <span style={{textDecoration: 'line-through'}}>540€</span> → 490€</strong></p>
        </div>
      </>
    )
  }
};
